import find from 'lodash/find'

import SurveyValue from './SurveyValue'
import classicJacket from '../../../svg/classic-jacket.svg'
import slimJacket from '../../../svg/slim-jacket.svg'

// NOTE: Do not use class directly except to check for type!
export default class Preference extends SurveyValue {
  constructor({description, icon, key, title}) {
    super(key)

    this.title = title
    this.description = description
    this.icon = icon
  }

  toLabel() {
    return this.title
  }

  static keyToObject(key) {
    return find(PREFERENCES, {key}) // eslint-disable-line no-use-before-define
  }
}

// NOTE: These `key`s reflect what is stored on the server (but as numbers instead of strings).
export const PREFERENCES = {
  CLASSIC: new Preference({
    key: '0',
    description: 'Room to move, but still not overly baggy.',
    icon: classicJacket,
    title: 'Classic',
  }),
  SLIM: new Preference({
    key: '1',
    description: 'A modern silhouette. Not too tight, but not loose either.',
    icon: slimJacket,
    title: 'Slim',
  }),
}
